/** Rules of the new firm setup steps (owner 2026-10-25, branch claude/team-onboarding). */

export type CountryCode = "CA" | "US" | "AU" | "GB";

export type FirmForm = {
  name: string;
  /** "" = not picked yet (owner 2026-10-25: new firms must pick; it sets the billing currency). */
  country: CountryCode | "";
  line1: string;
  line2: string;
  city: string;
  region: string;
  postalCode: string;
};

export const regionLabel = (country: CountryCode | "") =>
  country === "CA"
    ? "Province"
    : country === "GB"
    ? "County (optional)"
    : "State";

export const postalLabel = (country: CountryCode | "") =>
  country === "US" ? "ZIP code" : country === "CA" ? "Postal code" : "Postcode";

/** Problems per box of Step 2 (empty = ready). Same limits as before (name 2-100). */
export const firmStepProblems = (form: FirmForm) => {
  const problems: Partial<Record<keyof FirmForm, string>> = {};
  const name = form.name.trim();
  if (!name) problems.name = "Enter your firm's name.";
  else if (name.length < 2) problems.name = "Use at least 2 characters.";
  if (!form.country) problems.country = "Choose your firm's country.";
  if (!form.line1.trim()) problems.line1 = "Enter the street address.";
  if (!form.city.trim()) problems.city = "Enter the city.";
  if (form.country && form.country !== "GB" && !form.region.trim())
    problems.region =
      form.country === "CA" ? "Choose the province." : "Choose the state.";
  if (!form.postalCode.trim())
    problems.postalCode = `Enter the ${postalLabel(
      form.country,
    ).toLowerCase()}.`;
  return problems;
};

export type TeamRow = {
  firstName: string;
  lastName: string;
  email: string;
  level: string;
};

export const TEAM_LEVELS = [
  { level: "Staff (No Settings)", title: "Staff" },
  { level: "Staff (No Settings, No Billing)", title: "Staff, no billing" },
  { level: "Admin", title: "Admin" },
];

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** An empty row is fine (skipped); a started row needs first + last name and a valid email. */
export const teamRowProblem = (row: TeamRow): string | null => {
  const first = row.firstName.trim();
  const last = row.lastName.trim();
  const email = row.email.trim();
  if (!first && !last && !email) return null;
  if (!first || !last) return "Enter their first and last name.";
  if (!email) return "Enter their email address.";
  if (!EMAIL_RE.test(email)) return "Enter a valid email address.";
  return null;
};
